const FolderDocumentMiddle = ({ selectedCompany }) => {
  return <></>;
};

export default FolderDocumentMiddle;
